import { ComponentChildren } from "preact";

export function Section(props: Record<string, unknown>) {
  const dataAttributes: Record<string, string> = {};

  for (const key in props) {
    if (key.startsWith("data-"))
      dataAttributes[key] = props[key] + "";
  }

  return <section {...props} class="section" {...dataAttributes}>
    <div class="centered">
      {props.children as ComponentChildren}
    </div>
  </section>;
}

export function SectionSubtitle(props: { children: ComponentChildren; style?: Record<string, string> }) {
  return <div class="section-subtitle" style={props.style}>{props.children}</div>;
}